module.exports = __webpack_public_path__ + "static/media/icon_info.a36167d5.svg";